import { styled } from '@defa/defa-component-library';

export const LoadingWrapper = styled.div`
    display: flex;
    height: 100px;
    min-width: 100px;
    align-items: center;
`;
